import { ReactNode, useSyncExternalStore } from 'react'
import StrikePopover from './StrikePopover'

type ActivePopover = {
    id: string
    anchorEl: HTMLElement
    content: ReactNode
}

let activePopover: ActivePopover | null = null
const listeners = new Set<() => void>()

const notify = () => {
    listeners.forEach((listener) => listener())
}

const subscribe = (listener: () => void) => {
    listeners.add(listener)
    return () => listeners.delete(listener)
}

const getActivePopover = () => activePopover

export const openOptionChainPopover = (id: string, anchorEl: HTMLElement, content: ReactNode) => {
    activePopover = activePopover?.id === id ? null : { id, anchorEl, content }
    notify()
}

export const closeOptionChainPopover = () => {
    if (!activePopover) return
    activePopover = null
    notify()
}

export const useIsOptionChainPopoverActive = (id: string) =>
    useSyncExternalStore(
        subscribe,
        () => getActivePopover()?.id === id,
        () => false
    )

const OptionChainPopoverHost = () => {
    const active = useSyncExternalStore(subscribe, getActivePopover, () => null)

    return (
        <StrikePopover
            open={Boolean(active)}
            anchorEl={active?.anchorEl ?? null}
            handleClose={closeOptionChainPopover}
        >
            {active?.content}
        </StrikePopover>
    )
}

export const OptionChainPopoverProvider = ({ children }: { children: ReactNode }) => (
    <>
        {children}
        <OptionChainPopoverHost />
    </>
)
